import { render } from "./AppleStore.vue?vue&type=template&id=010d7a0b&ts=true"
import script from "./AppleStore.vue?vue&type=script&lang=ts"
export * from "./AppleStore.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__